import React from 'react';

import SignUp from '../SignUp/index';
import SignUpHeader from '../SignUpHeader/index';
import Subscribe from '../Subscribe/index';
import { BackgroundDiv, SignUpBackground, SignUpFormDiv} from './style';

const SignUpScreen = () => (
    <BackgroundDiv>
        <SignUpHeader />
        <SignUpBackground />
        <SignUpFormDiv>
            <SignUp />
            <Subscribe />
        </SignUpFormDiv>

    </BackgroundDiv>
);

export default SignUpScreen;